<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <h1 class="ts-uppercase ts-font-semibold ts-text-lg">
            {{ $t('studentEnrollment.accelerate') }}
          </h1>

          <div
            class="ts-border-2 ts-border-dashed ts-rounded-md ts-mt-4 ts-p-4"
          >
            <div class="row ts-space-y-2">
              <div class="col-md-12">
                <div class="ts-flex ts-items-center ts-justify-between">
                  <label class="required">{{
                    $t('studentEnrollment.currentClass')
                  }}</label>
                  <div class="ts-flex ts-mb-1">
                    <ts-checkbox v-model="current_ac_status_id" :value="2">{{
                      $t('invoice.history')
                    }}</ts-checkbox>
                    <ts-checkbox
                      class="ts-ml-3 ts-mr-3"
                      v-model="current_ac_status_id"
                      :value="1"
                      >{{ $t('invoice.current') }}</ts-checkbox
                    >
                  </div>
                </div>
                <treeselect
                  :load-options="loadCurrentClass"
                  :multiple="false"
                  :options="currentClass"
                  :placeholder="$t('select')"
                  v-model.number="model.old_class_id"
                  @input="onCurrentClassChange"
                />
                <div class="validate" v-if="errors.has('old_class_id')">
                  {{ errors.first('old_class_id') }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="ts-flex ts-items-center ts-justify-between">
                  <label class="required">{{
                    $t('studentEnrollment.newClass')
                  }}</label>
                  <div class="ts-flex ts-mb-1">
                    <ts-checkbox
                      v-model="ac_status_id"
                      :value="1"
                      @change="loadForwardClass"
                      >{{ $t('invoice.current') }}</ts-checkbox
                    >
                    <ts-checkbox
                      class="ts-ml-3 ts-mr-3"
                      v-model="ac_status_id"
                      :value="3"
                      @change="loadForwardClass"
                      >{{ $t('invoice.next') }}</ts-checkbox
                    >
                  </div>
                </div>
                <treeselect
                  :multiple="false"
                  :options="forwardClassOption"
                  :placeholder="$t('select')"
                  v-model.number="model.new_class_id"
                />
                <small
                  ><i
                    >Take only class operation in next/current status and the
                    next grade of current class.</i
                  ></small
                >
                <div class="validate" v-if="errors.has('new_class_id')">
                  {{ errors.first('new_class_id') }}
                </div>
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12">
                <div id="container-table">
                  <ts-table
                    :columns="columns"
                    :records="resources"
                    :showCheckbox="true"
                    @check-items="checkItem"
                  >
                    <template v-slot="{ record }">
                      <td>{{ record.student_profile.card_number }}</td>
                      <td>{{ record.student_profile.full_name_en }}</td>
                      <td class="text-center">
                        <a-select
                          :value="sessionId(record)"
                          mode="multiple"
                          :maxTagCount="2"
                          class="ts-w-full"
                          :options="sessionList"
                          @change=" e => handleSessionChange(e, record)"
                        ></a-select>
                      </td>
                      <td class="text-center">
                        <a-select
                          :disabled="record.session_id.length > 1"
                          :value="studyTimeId(record)"
                          class="ts-w-full"
                          :options="study_times"
                          :allowClear="true"
                          @change=" e => handleStudyTimeChange(e, record)"
                        ></a-select>
                      </td>
                      <td>{{ record.student_profile.gender }}</td>
                      <td>{{ record.student_profile.phone }}</td>
                    </template>
                  </ts-table>
                </div>
                <div class="validate" v-if="errors.has('student_list')">
                  {{ errors.first('student_list') }}
                </div>
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 text-right">
                <ts-button @click="$emit('close')" class="mr-2">{{
                  $t('cancel')
                }}</ts-button>
                <ts-button
                  color="primary"
                  outline
                  class="mr-2"
                  @click.prevent="storeStudentAccelerateNew"
                  >{{ $t('save_add_new') }}</ts-button
                >
                <ts-button
                  color="primary"
                  @click.prevent="storeStudentAccelerate"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { join } from 'lodash'
export default {
  data() {
    return {
      model: {
        old_class_id: null,
        new_class_id: null,
        student_list: []
      },
      errors: new Errors(),
      resources: [],
      currentClass: [],
      forwardClass: [],
      ac_status_id: [1],
      current_ac_status_id: [1],
      loading: false,
      study_times: [],
      sessionList: [
        {
          value: 1,
          label: 'Session 1'
        },
        {
          value: 2,
          label: 'Session 2'
        } 
      ],
    }
  },
  created() {
    this.loadCurrentClass({ action: LOAD_ROOT_OPTIONS })
  },
  computed: {
    columns() {
      return [
        { name: this.$t('studentEnrollment.studentCard'), style: 'z-index:0' },
        { name: this.$t('studentEnrollment.studentName'), style: 'z-index:0' },
        { 
          name: this.$t('studentEnrollment.session'),
          style: 'text-align:center'
        },
        { 
          name: this.$t('studentEnrollment.studyTime'),
          style: 'text-align:center'
        },
        { name: this.$t('studentEnrollment.gender'), style: 'z-index:0' },
        { name: this.$t('studentEnrollment.phone'), style: 'z-index:0' }
      ]
    },
    forwardClassOption() {
      return this.forwardClass.map(el => ({
        id: el.class_id,
        label: `${el.class_name} | ${el.teacher_name}  
								| ${el.study_time}
								| ${el.ac_status_description}
                | ${el.ac_year}
								| ${el.term_name}`
      }))
    },
    sessionId: () => sessionId => {
      return sessionId.session_id ? sessionId.session_id.split(',').map(Number) : undefined
    },
    studyTimeId: () => studyTimeId => {
      return studyTimeId.session_id.length > 1 ? studyTimeId.academic_class.academic_study_time.ac_st_id : (studyTimeId.ac_st_id ? studyTimeId.ac_st_id : null)
    }
  },
  methods: {
    ...mapActions('studentEnrollment', [
      'getClassOperation',
      'fetchStudentEnrollByClass',
      'getClassOfNextGrade',
      'getStudyTime',
      'accelerateStudent'
    ]),
    handleSessionChange(value, record) {
      record.session_id = value.join(',')
    },
    handleStudyTimeChange(value, record) {
      record.ac_st_id = value
    },
    async loadCurrentClass({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getClassOperation({
          perPage: -1,
          filter: {
            ac_status_id: join(this.current_ac_status_id, ',')
          }
        })
          .then(response => {
            this.currentClass = response.data.map(el => ({
              grade_id: el.grade_id,
              id: el.class_id,
              label: `${el.class_name} | ${el.teacher_name}  
								| ${el.study_time}
								| ${el.ac_status_description}
                | ${el.ac_year}
								| ${el.term_name}`
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    async filterStudent() {
      return this.fetchStudentEnrollByClass({
        page: -1,
        filter: {
          class_id: this.model.old_class_id
        }
      })
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    checkItem(items) {
      this.model.student_list = items.map(el => ({
        student_id: el.student_id,
        session_id: el.session_id,
        ac_st_id: el.ac_st_id
      }))
    },
    async onCurrentClassChange(value) {
      this.loading = true
      if (this.model.old_class_id !== undefined) {
        await this.filterStudent()
        const findGrade = this.currentClass.find(g => g.id === value)
        console.log(findGrade);
        if (findGrade) {
          await this.getClassOfNextGrade({
            gradeId: findGrade.grade_id,
            params: {
              ac_status_id: this.ac_status_id
            }
          }).then(response => {
            this.forwardClass = response.data
          })
        }
        this.loading = false
      }
    },
    async loadForwardClass() {
      if (!this.model.old_class_id) return
      this.loading = true
      this.model.new_class_id = ''
      const findGrade = this.currentClass.find(
        g => g.id === this.model.old_class_id
      )
      if (findGrade) {
        await this.getClassOfNextGrade({
          gradeId: findGrade.grade_id,
          params: {
            ac_status_id: this.ac_status_id
          }
        })
          .then(response => {
            this.forwardClass = response.data
          })
          .finally(() => (this.loading = false))
      }
    },
    clearInput() {
      this.model = {
        old_class_id: null,
        new_class_id: null,
        student_list: []
      }
    },
    fetchStudyTime(){
      this.loading = true
			this.getStudyTime()
				.then(response => {
						this.study_times = response.data.map(el => ({
							value: el.ac_st_id,
							label: el.study_time
						}))
				})
				.finally(() => {
					this.loading = false
				})
		},
    storeStudentAccelerate() {
      this.loading = true
      this.$store
        .dispatch('studentEnrollment/accelerateStudent', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    storeStudentAccelerateNew() {
      this.loading = true
      this.$store
        .dispatch('studentEnrollment/accelerateStudent', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    'model.old_class_id': function() {
      this.model.student_list = []
      this.model.new_class_id = null
      this.resources = []
      this.fetchStudyTime()
    },
    current_ac_status_id: function() {
      this.model.student_list = []
      this.model.new_class_id = null
      this.model.old_class_id = null
      this.resources = []
      this.loadCurrentClass({ action: LOAD_ROOT_OPTIONS }).finally(
        () => (this.loading = false)
      )
    }
  }
}
</script>
